<template>
  <div class="resultCard">
    <div class="tips">
      <p class="tips-1">{{ resultState.resultTips || $t("completed") }}</p>
    </div>
    <a
      href="javascript:void(0)"
      class="collectBtn"
      v-if="finishConfig && !resultState.hasCollect"
      @click="changeResultRoute('collectInfo')"
      >{{ $t("leaveMessage") }}</a
    >
  </div>
</template>
<script setup>
import resultHook from "@/hooks/resultHook";
const { changeResultRoute, finishConfig, resultState, getSurveyAward } =
  resultHook();
resultState.isCoupon && getSurveyAward();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.resultCard {
  padding: 20px;
  @media (orientation: landscape) {
    padding: 20px;
  }
  .tips-1 {
    color: $btnColor;
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
    line-height: 1.5;
    @media (orientation: landscape) {
      font-size: 30px;
      margin-bottom: 20px;
    }
  }
}
</style>
